const Tab = ({ children }) => children;
export default Tab;
